var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var FlagBr16 = function FlagBr16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 11.296c0 .838.671 1.517 1.5 1.517h12c.829 0 1.5-.68 1.5-1.517v-7.28c0-.837-.671-1.516-1.5-1.516H2c-.828 0-1.5.679-1.5 1.516v7.28z",
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.053 7.682-6.07 3.935-6.07-3.935 6.07-3.935 6.07 3.935z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.774 6.673c1.386 0 2.629.516 3.477 1.332a2.62 2.62 0 0 1 .024-.323c0-1.28-1.026-2.317-2.292-2.317-.937 0-1.74.569-2.097 1.383.288-.047.584-.075.888-.075",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62 6.986c-.288 0-.568.024-.841.067a2.332 2.332 0 0 0-.088.63C5.69 8.962 6.717 10 7.983 10a2.295 2.295 0 0 0 2.184-1.613c-.849-.856-2.123-1.401-3.548-1.401",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84 6.791c.014-.04.03-.08.046-.119-.017.04-.031.08-.047.12z",
    fill: "#2880B9"
  })));
};

FlagBr16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '16': FlagBr16
};
export var FlagBr = function FlagBr(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '16' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['16'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'FlagBr' icon. Please use one of the available sizes: '16'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};